export async function getImageInfo(imageUrl: string): Promise<any> {
    const img = new Image()

    return new Promise((resolve, reject) => {
        img.onload = () => {
            resolve(img)
        }

        img.onerror = () => {
            reject(new Error("failed to load image"))
        }

        img.src = imageUrl
    })
}